'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _Scaler = require('./Scaler');

var _Scaler2 = _interopRequireDefault(_Scaler);

var _canvasToBlob = require('./canvasToBlob.polyfills');

var _canvasToBlob2 = _interopRequireDefault(_canvasToBlob);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};

function isImage(file) {
    return file.type && /^image\//g.test(file.type);
}
;
var startX = 0;
var startY = 0;
var Δleft = 0;
var Δtop = 0;
var left = 0;
var top = 0;
var dragging = false;
function limit(value, limitArray) {
    var min = Math.min(limitArray[0], limitArray[1]);
    var max = Math.max(limitArray[0], limitArray[1]);
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
}

var Cropper = function (_React$Component) {
    _inherits(Cropper, _React$Component);

    function Cropper(props) {
        _classCallCheck(this, Cropper);

        var _this = _possibleConstructorReturn(this, (Cropper.__proto__ || Object.getPrototypeOf(Cropper)).call(this, props));

        _this.updateThumbnail = (0, _utils.debounce)(function () {
            var _this$state = _this.state,
                image = _this$state.image,
                width = _this$state.width,
                height = _this$state.height;

            if (_this.refNodes) {
                var _arr = ['Canvas2x', 'Canvas1x'];

                for (var _i = 0; _i < _arr.length; _i++) {
                    var item = _arr[_i];
                    if (_this.refNodes[item]) {
                        _this.refNodes[item].getContext('2d').drawImage(image, left, top, width, height);
                    }
                }
            }
        }, 100);
        _this.readFile = function (file) {
            var reader = new FileReader();
            if (file && isImage(file)) {
                reader.readAsDataURL(file);
            }
            reader.onload = function () {
                return _this.loadImage(reader);
            };
        };
        _this.loadImage = function (reader) {
            // const reader = new FileReader();
            var image = new Image();
            // Although you can use images without CORS approval in your canvas, doing so taints the canvas.
            // Once a canvas has been tainted, you can no longer pull data back out of the canvas.
            // For example, you can no longer use the canvas toBlob(), toDataURL(), or getImageData() methods;
            // doing so will throw a security error.
            // This protects users from having private data exposed by using images
            // to pull information from remote web sites without permission.
            image.setAttribute('crossOrigin', 'anonymous');
            image.onload = function () {
                return _this.normalizeImage(image);
            };
            image.src = reader.result;
        };
        _this.scaleImage = function (scale) {
            if (scale === _this.state.scale) {
                return;
            }
            var _this$state$image = _this.state.image,
                width = _this$state$image.width,
                height = _this$state$image.height;

            var imageState = {
                width: width * scale,
                height: height * scale
            };
            _this.setState({
                scale: scale,
                width: imageState.width,
                height: imageState.height,
                widthLimit: [_this.state.viewport[0] - imageState.width, 0],
                heightLimit: [_this.state.viewport[1] - imageState.height, 0]
            });
            left = limit((_this.state.viewport[0] - imageState.width) / 2 + Δleft, [_this.state.viewport[0] - imageState.width, 0]);
            top = limit((_this.state.viewport[1] - imageState.height) / 2 + Δtop, [_this.state.viewport[1] - imageState.height, 0]);
            _this.applyPositions();
        };
        _this.applyImageState = function (imageState) {
            _this.setState({
                width: imageState.width,
                height: imageState.height,
                widthLimit: [_this.state.viewport[0] - imageState.width, 0],
                heightLimit: [_this.state.viewport[1] - imageState.height, 0]
            }, _this.updateThumbnail);
            left = (_this.state.viewport[0] - imageState.width) / 2;
            top = (_this.state.viewport[1] - imageState.height) / 2;
            _this.applyPositions();
        };
        // 初始化 Cropper，图片的尺寸会默认 fit 320 * 320
        _this.normalizeImage = function (image) {
            var _imageState;

            var width = image.width,
                height = image.height;
            var viewport = _this.state.viewport;

            var widthProportional = width / viewport[0];
            var heightProportional = height / viewport[1];
            var ΔProportional = widthProportional / heightProportional;
            var IdpVar = ΔProportional > 1 ? 'height' : 'width'; // 自变量
            var depVar = ΔProportional > 1 ? 'width' : 'height'; // 因变量
            var scale = Number((viewport[Number(ΔProportional > 1)] / image[IdpVar]).toFixed(4));
            // console.log('基准缩放属性：', IdpVar,':', image[IdpVar], 'px',
            //             '缩放至:', viewport[Number(ΔProportional > 1)], 'px',
            //             '缩放比例：', scale); // tslint:ignore
            var imageState = (_imageState = {}, _defineProperty(_imageState, IdpVar, viewport[Number(ΔProportional > 1)]), _defineProperty(_imageState, depVar, viewport[Number(ΔProportional > 1)] / viewport[Number(ΔProportional > 1)] * image[depVar] * scale), _imageState);
            _this.setState({
                image: image,
                scale: scale,
                scaleRange: [scale, 1.777],
                visible: true
            }, function () {
                return _this.applyImageState(imageState);
            });
        };
        _this.applyPositions = function () {
            if (_this.refNodes.viewport) {
                (0, _utils.applyTransform)(_this.refNodes.viewport, 'translate3d(' + left + 'px,' + top + 'px,0)');
            }
            if (_this.refNodes.dragger) {
                (0, _utils.applyTransform)(_this.refNodes.dragger, 'translate3d(' + left + 'px,' + top + 'px,0)');
            }
        };
        _this.onMouseDown = function () {
            _this.setState({
                dragging: true
            });
        };
        _this.dragStart = function (ev) {
            dragging = true;
            startX = ev.clientX;
            startY = ev.clientY;
        };
        _this.dragOver = function (ev) {
            if (dragging) {
                Δleft += ev.clientX - startX;
                Δtop += ev.clientY - startY;
                left = limit(left + (ev.clientX - startX), _this.state.widthLimit);
                top = limit(top + (ev.clientY - startY), _this.state.heightLimit);
                startX = ev.clientX;
                startY = ev.clientY;
                _this.applyPositions();
                _this.updateThumbnail();
                // 拖动后，不再提示可拖动
                if (_this.refNodes.dragNotice) {
                    _this.refNodes.dragNotice.style.display = 'none';
                }
            }
        };
        _this.dragEnd = function () {
            dragging = false;
        };
        _this.handleCancel = function () {
            _this.props.onChange(null);
            _this.hideModal();
        };
        _this.handleOk = function () {
            var _this$state2 = _this.state,
                image = _this$state2.image,
                width = _this$state2.width,
                height = _this$state2.height,
                scale = _this$state2.scale,
                viewport = _this$state2.viewport;
            var resizer = _this.props.resizer;

            (0, _utils.downScaleImage)(image, scale, resizer).then(function (scaledImage) {
                var canvas = document.createElement('canvas');
                canvas.style.width = viewport[0] + 'px';
                canvas.style.height = viewport[1] + 'px';
                canvas.setAttribute('width', viewport[0]);
                canvas.setAttribute('height', viewport[1]);
                var context = canvas.getContext('2d');
                if (!context) {
                    return;
                }
                if (!/image\/png/g.test(_this.props.file.type)) {
                    context.fillStyle = '#fff';
                    context.fillRect(0, 0, viewport[0], viewport[1]);
                }
                // if circle...
                if (_this.props.circle) {
                    context.save();
                    context.beginPath();
                    context.arc(viewport[0] / 2, viewport[1] / 2, Math.min(viewport[0] / 2, viewport[1] / 2), 0, Math.PI * 2, true);
                    context.closePath();
                    context.clip();
                }
                context.drawImage(scaledImage, left, top, width, height);
                if (_this.props.circle) {
                    context.beginPath();
                    context.arc(0, 0, 2, 0, Math.PI, true);
                    context.closePath();
                    context.restore();
                }
                if (canvas.toBlob) {
                    canvas.toBlob(function (blob) {
                        _this.props.onChange(blob);
                        _this.hideModal();
                    }, _this.props.file.type);
                } else {
                    var dataUrl = canvas.toDataURL(_this.props.file.type);
                    _this.props.onChange((0, _canvasToBlob2['default'])(dataUrl));
                    _this.hideModal();
                }
            });
        };
        _this.hideModal = function () {
            _this.setState({
                visible: false
            });
            document.body.style.overflow = '';
        };
        _this.getThumbnailSize = function (index) {
            var _this$props = _this.props,
                size = _this$props.size,
                thumbnailSizes = _this$props.thumbnailSizes;

            if (thumbnailSizes && thumbnailSizes.hasOwnProperty(index)) {
                return thumbnailSizes[index];
            }
            if (index === 0) {
                return [size[0] * 2, size[1] * 2];
            }
            return [size[0], size[1]];
        };
        var size = props.size;

        var imageState = void 0;
        if (size[0] === size[1]) {
            imageState = {
                width: 320,
                height: 320
            };
        } else {
            imageState = {
                height: 320,
                width: 320 / size[1] * size[0]
            };
        }
        _this.state = {
            image: null,
            viewport: [imageState.width, imageState.height],
            width: 320,
            height: 320,
            dragging: false,
            scaleRange: [1, 1],
            scale: 1,
            visible: false
        };
        _this.refNodes = {};
        return _this;
    }

    _createClass(Cropper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.readFile(this.props.file);
            document.addEventListener('mouseup', this.dragEnd);
            document.addEventListener('mousemove', this.dragOver);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('mouseup', this.dragEnd);
            document.removeEventListener('mousemove', this.dragOver);
        }
    }, {
        key: 'applyRef',
        value: function applyRef(refName, ele) {
            this.refNodes[refName] = ele;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                prefixCls = _props.prefixCls,
                circle = _props.circle,
                spin = _props.spin,
                renderModal = _props.renderModal;
            var _state = this.state,
                image = _state.image,
                width = _state.width,
                height = _state.height,
                scale = _state.scale,
                scaleRange = _state.scaleRange,
                viewport = _state.viewport;

            var style = { left: 0, top: 0 };
            var draggerEvents = {
                onMouseDown: this.dragStart
            };
            var footer = [React.createElement(_Scaler2['default'], { key: "scaler", prefixCls: prefixCls, onChange: this.scaleImage, value: scale, min: scaleRange[0], max: scaleRange[1] }), React.createElement("button", { className: prefixCls + '-btn ' + prefixCls + '-btn-ghost', key: "back", type: "ghost", onClick: this.handleCancel }, (0, _utils.getLocale)('cancel', this.props.locale)), React.createElement("button", { className: prefixCls + '-btn ' + prefixCls + '-btn-primary', key: "submit", type: "primary", onClick: this.handleOk }, (0, _utils.getLocale)('submit', this.props.locale))];
            var viewPortStyle = { width: viewport[0], height: viewport[1] };
            var previewClassName = circle ? 'radius' : '';
            var cropperElement = image ? React.createElement("div", { className: prefixCls + '-cropper-wrapper' }, React.createElement("div", { className: prefixCls + '-cropper' }, React.createElement("div", { className: prefixCls + '-thumbnail', style: viewPortStyle }, React.createElement("div", { className: "thumbnail-window", style: viewPortStyle }, React.createElement("img", { src: image.src, ref: this.applyRef.bind(this, 'viewport'), width: width, height: height, style: style })), React.createElement("img", __assign({}, draggerEvents, { ref: this.applyRef.bind(this, 'dragger'), src: image.src, width: width, height: height, style: style, className: prefixCls + '-background', draggable: false })), scale > scaleRange[0] ? React.createElement("div", { className: "candrag-notice-wrapper", ref: "dragNotice" }, React.createElement("span", { className: "candrag-notice" }, (0, _utils.getLocale)('drag to crop', this.props.locale))) : null)), React.createElement("div", { className: prefixCls + '-thumbnail-preview' }, React.createElement("h4", null, (0, _utils.getLocale)('preview', this.props.locale)), React.createElement("div", { className: "size-2x" }, React.createElement("canvas", { className: previewClassName, ref: this.applyRef.bind(this, 'Canvas2x'), width: viewport[0], height: viewport[1], style: { width: this.getThumbnailSize(0)[0], height: this.getThumbnailSize(0)[1] } }), React.createElement("p", null, "2x: ", this.getThumbnailSize(0)[0] + 'px * ' + this.getThumbnailSize(0)[1] + 'px')), React.createElement("div", { className: "size-1x" }, React.createElement("canvas", { className: previewClassName, ref: this.applyRef.bind(this, 'Canvas1x'), width: viewport[0], height: viewport[1], style: { width: this.getThumbnailSize(1)[0], height: this.getThumbnailSize(1)[1] } }), React.createElement("p", null, "1x: ", this.getThumbnailSize(1)[0] + 'px * ' + this.getThumbnailSize(1)[1] + 'px')))) : null;
            if (image) {
                return React.createElement("div", null, spin, renderModal ? React.cloneElement(renderModal(), {
                    visible: this.state.visible,
                    title: (0, _utils.getLocale)('edit picture', this.props.locale),
                    width: 800,
                    footer: footer,
                    onCancel: this.handleCancel
                }, cropperElement) : React.createElement("div", null, cropperElement, " ", footer));
            }
            return React.createElement("span", null, " loading... ");
        }
    }]);

    return Cropper;
}(React.Component);

exports['default'] = Cropper;

Cropper.defaultProps = {
    prefixCls: 'rc',
    size: [32, 32],
    circle: false,
    onChange: function onChange() {},
    locale: 'en-US'
};
module.exports = exports['default'];